import { glyphs, type IconName } from './glyphs';
import './Icon.styl';

export type { IconName };

/** `strokeWidth` is kept for callers of the former SVG set; a heavier stroke draws the glyph a little bolder. */
type Props = { name: IconName; size?: number; strokeWidth?: number; className?: string };

/** An IcoMoon glyph (the default icon font); decorative, hidden from assistive technology. */
export function Icon({ name, size = 17, strokeWidth = 1.5, className }: Props) {
  const classes = ['a-icon', `icon-${glyphs[name]}`];
  if (strokeWidth >= 2) classes.push('a-icon--bold');
  if (className) classes.push(className);
  return <span className={classes.join(' ')} style={{ fontSize: size, width: size, height: size }} aria-hidden="true" />;
}
